<template>
  <div>
    <!-- <v-stepper :active="webStepId" v-model="e1" class="elevation-0 transparent"> -->
    <v-stepper v-if="step <= 6" :value="this.step" class="elevation-0 transparent">
      <v-stepper-header align-center justify-center>
        <v-spacer></v-spacer>
        <v-stepper-step :style="getFontProperty()" :complete="step > 1" step="1">{{$translate('STEP_THEME')}}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :style="getFontProperty()" :complete="step > 2" step="2">{{$translate('STEP_DETAILS')}}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :style="getFontProperty()" :complete="step > 3" step="3">{{$translate('STEP_WISHLIST')}}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :style="getFontProperty()" :complete="step > 4" step="4">{{$translate('STEP_PLAN')}}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :style="getFontProperty()" :complete="step > 5" step="5">{{$translate('STEP_CONFIRM')}}</v-stepper-step>
         <v-spacer></v-spacer>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ui_helpers } from '../shared/ui_helpers';
export default {
  mixins: [ui_helpers],

  computed: {
    ...mapGetters({
      webStep: "getWebStepId",
    })
  },
  watch: {
    webStep: function(newV, oldV) {
      this.step = this.webStep;
      console.log("new webstepper step: ", this.step)
    }
  },
  mounted() {
    this.step = this.webStep;
    console.log("webstepper step: ", this.step)
  },
  methods: {},
  data() {
    return {
      step: 1
    };
  },
  created() {}
};
</script>
